/**
 * AttachmentList.jsx
 * Path: frontend/src/components/AttachmentList.jsx
 * Description: Lista i upload załączników zlecenia.
 * Related: pages/JobDetailPage.jsx
 */

import { useState } from "react";
import AttachmentPreviewModal from "./AttachmentPreviewModal";
import AttachmentTile from "./AttachmentTile";

export default function AttachmentList({
  token,
  jobId,
  attachments,
  uploading,
  deletingAttachmentId,
  onUpload,
  onDownload,
  onDelete,
}) {
  const [previewItem, setPreviewItem] = useState(null);

  return (
    <>
      <section className="card-section">
        <div className="section-header">
          <div>
            <h2>Multimedia</h2>
            <p>Zdjęcia, filmy i dokumenty powiązane ze zleceniem.</p>
          </div>
          <label className="primary-button primary-button-file">
            <input
              type="file"
              accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
              multiple
              onChange={(event) => {
                const files = Array.from(event.target.files || []);
                if (files.length > 0) onUpload(files);
                event.target.value = "";
              }}
              disabled={uploading}
            />
            {uploading ? "Wysyłanie..." : "Dodaj"}
          </label>
        </div>

        <div className="attachment-gallery">
          {attachments.length === 0 ? <div className="empty-state">Brak dodanych plików.</div> : null}
          {attachments.map((attachment) => (
            <AttachmentTile
              key={attachment.id}
              token={token}
              jobId={jobId}
              attachment={attachment}
              deleting={deletingAttachmentId === attachment.id}
              showDelete
              onDownload={onDownload}
              onDelete={onDelete}
              onPreview={setPreviewItem}
            />
          ))}
        </div>
      </section>

      <AttachmentPreviewModal item={previewItem} onClose={() => setPreviewItem(null)} />
    </>
  );
}
